<template>
  <b-modal v-model="show" ref="showBatchAddTournamentModal" size="lg" centered header-bg-variant="primary" hide-footer title="Batch Add Tournament" @hide="cancelBatchAddTournamentModal()">
    <div class="d-block">
      <b-row>
        <b-col sm="12">
          <div class="mb-3">
            <label for="groupId">Upload File</label>
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="customFile" @change="handleFileChange">
              <label class="custom-file-label" for="customFile">{{ form.uploadedFileName }}</label>
            </div>
            <small id="passwordHelpBlock" class="form-text text-muted">
              Suppported extension (.xlsx | .xls)
            </small>
            <div v-if="$v.form.uploadFile.$error">
              <div class="invalid-feedback d-block" v-if="!$v.form.uploadFile.required">Please upload file.</div>
              <div class="invalid-feedback d-block" v-if="!$v.form.uploadFile.fileType">Invalid File Format. Must be (.xlsx | .xls)</div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-button variant="success" @click="uploadBatchQuickTournament()">Upload</b-button>
    <b-button variant="outline-danger" @click="cancelBatchAddTournamentModal()">Cancel</b-button>
  </b-modal>
</template>

<script>
import VueNotifications from 'vue-notifications'
import {Events} from '../../../events.js'
const {required} = require('vuelidate/lib/validators')
export default {
  data: () => {
    return {
      form: {
        uploadedFileName: 'Choose File',
        uploadFile: ''
      }
    }
  },
  computed: {
    show: {
      get: function () {
        return this.showBatchAddModal
      },
      set: function () {
        return this.showBatchAddModal
      }
    }
  },
  props: {
    showBatchAddModal: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    form: {
      uploadFile: {
        required,
        fileType: function (e) {
          if (!e) return true
          let type = e.name ? e.name.split('.').reverse()[0] : ''
          return (type !== '' && (type === 'xlsx' || type === 'xls'))
        }
      }
    }
  },
  methods: {
    handleFileChange (e) {
      this.form.uploadedFileName = e.target.files[0].name
      this.form.uploadFile = e.target.files[0]
    },
    cancelBatchAddTournamentModal () {
      this.$v.form.$reset()
      this.form.uploadedFileName = 'Choose File'
      this.form.uploadFile = ''
      this.$emit('cancelBatchAdd')
    },
    async uploadBatchQuickTournament () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        } else {
          let data = new FormData()
          data.append('file', this.form.uploadFile)
          await this.$http.post(this.API_ENDPOINT + '/tournament/main/batch/set', data)
          Events.$emit('alert', VueNotifications.types.success, 'Success', 'Batch Tournament Added Successfully')
          this.cancelBatchAddTournamentModal()
        }
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/tournament/MainTournament/BatchAddTournament.vue